/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Toolbar_LabelInputs */



/**
* | output |
* | --- |
* | "Toolbar with button groups" |
*
* @param {Explorer_Info_Toolbar_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_toolbar_label = /** @type {((inputs?: Explorer_Info_Toolbar_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Toolbar_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Barre d'outils avec groupes de boutons")
	if (locale === "de") return /** @type {LocalizedString} */ ("Symbolleiste mit Schaltflächengruppen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Barra degli strumenti con gruppi di pulsanti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Панель инструментов с группами кнопок")
	if (locale === "es") return /** @type {LocalizedString} */ ("Barra de herramientas con grupos de botones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("带有按钮组的工具栏")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ボタングループ付きのツールバー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बटन समूहों के साथ टूलबार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Barra de ferramentas com grupos de botões")
	return /** @type {LocalizedString} */ ("Toolbar with button groups")
});